<div class="row w-100" *ngIf="listSoloFolio.length > 0">
    <div class="col-sm-12">
        <mat-card class="shadow-none warning-card-print">
            <mat-card-content class="py-2 px-3">
                <div style="color: #856404; font-size: 14px; line-height: 1.5;">
                    <strong>Importante:</strong> Los códigos de por lo menos un reporte de ventas (F29) no fueron validados en SII, debido a indisponibilidad de fuente.
                    
                    <mat-icon 
                        class="align-middle mb-1 ms-1 icon-warning-print" 
                        aria-hidden="false" 
                        aria-label="Error icon" 
                        fontIcon="error"
                        [matTooltip]="mostrarDetalle ? 'Ocultar Detalle' : 'Mostrar Detalle'"
                        (click)="mostrarDetalle = !mostrarDetalle"
                    >
                    </mat-icon>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="col-sm-12 py-3 px-5" [class.hide-on-screen]="!mostrarDetalle">
        <span class="mb-3 font-weight-bold">
            <mat-icon 
                class="align-middle mb-1 ms-1 icon-warning-print" 
                aria-hidden="false" 
                aria-label="Warning icon" 
                fontIcon="warning"
                style="color: #FFC107 !important;"
            ></mat-icon>
            Listado de Meses/Periodos no validados en SII
        </span>
        <mat-chip-listbox aria-label="Lista de meses">
            <mat-chip *ngFor="let item of listSoloFolio" class="chip-periodo">
                {{ item.displayMes }} • {{ item.periodo }} 
            </mat-chip>
        </mat-chip-listbox>
    </div>
</div>
